import { Nav } from './Nav';

export const Header = () => {
  return (    
    <header className="fixed top-0 w-full max-w-screen-xl bg-white border-b border-gray z-10">
      <Nav></Nav>
    </header>
  );
}